import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { IBlogPostModel } from '@models';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BlogService {

  constructor(
    private firestore: AngularFirestore
  ) { }

  createBlogPost(data: IBlogPostModel) {
    return new Promise<any>((resolve, reject) =>{
      this.firestore
          .collection('blog-posts')
          .add(data)
          .then(res => {}, err => reject(err));
      });
  }

  getBlogPosts() {
    return this.firestore
      .collection('blog-posts')
      .valueChanges();
  }
}
